/* istanbul ignore file */
import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { StoryBoxGroup } from '../StoryBoxGroup';

export const StyledStoryBoxGroup = styled(StoryBoxGroup)<{
    $isFiltersApplied?: boolean;
}>`
    /* stylelint-disable unit-allowed-list */
    .story-box-list {
        display: grid;
        grid-template-columns: 100%;
        gap: ${({ theme }: { theme: Theme }) => theme.tggSpacing(rem(2), 8)};

        ${({ theme }: { theme: Theme }) => theme.breakpoints.up('mobile')} {
            grid-template-columns: repeat(6, 1fr);
            gap: ${({ theme }: { theme: Theme }) =>
                theme.tggSpacing([rem(4), rem(2)], [16, 8])};
            .story-box-item {
                grid-column: span 2;
            }

            .story-box-item:nth-of-type(1),
            .story-box-item:nth-of-type(2) {
                grid-column: ${({ $isFiltersApplied }) =>
                    $isFiltersApplied ? 'span 2' : 'span 3'};
            }
        }
    }
`;
